@if (isLoading) {
  <div class="currency-select-skeleton">
    <div class="skeleton-label"></div>
    <div class="skeleton-dropdown"></div>
  </div>
} @else if (businessAccountCurrencyList.length) {
  <app-form-select-field
    [label]="'Display Currency:'"
    class="currency-select-field"
    [selectedItem]="selectedCurrency"
    [items]="businessAccountCurrencyList"
    (changed)="onCurrencySelect($event)"
  ></app-form-select-field>
}
